import { useQuery, UseQueryResult } from 'react-query';
import { GymAthleteRetrieve } from 'types';
import { client } from 'utils/api-client';

function useGymAthleteRetrieve(gymId?: string | null): UseQueryResult<{ data: GymAthleteRetrieve }> {
  return useQuery(['gyms', gymId, 'athlete-retrieve'], () => client.get(`gyms/${gymId}/athlete-retrieve/`), {
    enabled: !!gymId,
  });
}

export default useGymAthleteRetrieve;
